export default __webpack_public_path__ + "static/media/Christmas_08.0e23aad2.png";